import { agentTestEvents } from '@shared/services/agent-test';
import { socket } from '../..';

export const handleAgentTestChangeCurrentAgent = () => {
  return socket.onMessage('CHANGE_CURRENT_AGENT', (payload) => {
    const newAgentId = Number(payload.current_agent_id);

    if (!Number.isFinite(newAgentId)) return;

    agentTestEvents.emitSwitchAgent({
      source: 'CHANGE_CURRENT_AGENT',
      newAgentId,
    });
  });
};
